export default "__VITE_ASSET__CE9hrw4p__"